<template>
  <a
    v-if="hasBadge"
    rel="nofollow"
    :href="tagUrl"
    class="article__badge flex items-center justify-center w-9 h-9 sm:w-11 sm:h-11"
    :class="{
      'article__badge--pin z-2 absolute top-0 transform translate-x-1 -translate-y-2 sm:-translate-x-4 sm:-translate-y-4': pin === 'left',
      'article__badge--pin z-2 absolute top-0 transform right-0 -translate-x-1 -translate-y-2 sm:translate-x-4 sm:-translate-y-4':
        pin === 'right',
    }"
    :style="sizeStyle"
    aria-label="etiket"
    :title="title"
    v-bind="bind"
  >
    <OImage
      loading="lazy"
      :src="badgeUrl"
      class="article__badge-img w-9 h-9 sm:w-11 sm:h-11"
      :class="{ 'rounded-full': isBadgeGif }"
      :style="{ ...sizeStyle }"
      alt="etiket"
    />
  </a>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OImage },
  props: {
    size: {
      default: null,
      type: String | Number,
    },
    pin: {
      type: String,
    },
    hp4uAttrs: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article', null);
    const hasBadge = computed(() => article?.badges?.length);
    const title = computed(() => article?.title);
    const articleBadge = computed(() => article?.badges?.[0]);
    const isBadgeGif = computed(() => articleBadge?.value?.icons?.gif);
    const badgeUrl = computed(() => articleBadge?.value?.icons?.gif || articleBadge?.value?.icons?.svg || articleBadge?.value?.icons?.png);
    const sizeStyle = computed(() => {
      if (!props.size) return {};
      return {
        width: props.size + 'px',
        height: props.size + 'px',
      };
    });
    const tagUrl = computed(() => articleBadge?.value?.route);

    // Taboola Hp4u Attrs
    const bind = props.hp4uAttrs ? { 'data-tb-badge': '' } : {};

    return {
      hasBadge,
      isBadgeGif,
      badgeUrl,
      sizeStyle,
      tagUrl,
      title,
      bind,
    };
  },
});
</script>

<style>
.article__badge {
  border-radius: 50%;
  background: #ffe400;
  line-height: 14px;
}
.article__badge--pin {
  position: absolute !important;
}
.article__badge-img {
  background-size: contain;
  background-repeat: no-repeat;
  display: block;
  padding: 0;
}
</style>
